module.exports = __webpack_public_path__ + "static/media/ENGProjectPreview3w1100@1x.5122cd32.webp";